import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import { formatUrl } from '@ifeng-fe/public_method';
import styles from './index.css';
import { classnames } from '../../../utils/classnames';
import { rel as relText } from '../../../utils/rel';

class NavList extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        columnId: PropTypes.string,
    };

    navHrefView(list = [], columnId) {
        const idReg = new RegExp(`/${columnId}/`, 'ig');

        return list.map((item, index) => {
            const isThis = idReg.test(item.url);

            return (
                <a
                    key={index}
                    className={styles.navitem + (isThis ? ` ${styles.active}` : '')}
                    href={item.url}
                    target="_blank"
                    rel={relText}>
                    <b className={styles.cn}>{item.title}</b>
                    <span className={styles.en}>{item.name}</span>
                </a>
            );
        });
    }

    render() {
        const { content, columnId } = this.props;

        return <div className={classnames(styles.nav, 'clearfix')}>{this.navHrefView(content, columnId)}</div>;
    }
}

class Nav extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { channel, topNav, columnId } = this.props.content;
        const channel0 = channel.length > 0 ? channel[0] : null;

        return (
            <div className={styles.navbox}>
                <div className={classnames(styles.navbox2, 'clearfix')}>
                    {channel0 ? (
                        <a className={styles.logo} href={formatUrl(channel0.domain)} target="_blank" rel={relText}>
                            <img src={channel0.logo} alt={channel0.title} />
                        </a>
                    ) : null}
                    <Chip id={30085} type="struct" title="导航" groupName="导航" content={topNav}>
                        <NavList columnId={columnId} />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default Nav;
